import { render, staticRenderFns } from "./ConsultHubPage.vue?vue&type=template&id=1da98d36"
import script from "./ConsultHubPage.vue?vue&type=script&lang=ts"
export * from "./ConsultHubPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultHubPage.vue?vue&type=style&index=0&id=1da98d36&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports